import React from 'react';
import { arrayOf, string } from 'prop-types';
import { Guarantee } from '@magalu/stereo-ui-icons';
import { Box, Flex } from '../../atoms';
import { GuaranteeText, Title } from './delivery-guarantee.styles';

const GuaranteeDetails = ({
  text,
  title
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    p: 16
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Guarantee, {
    mr: 16,
    width: 45,
    height: 35
  }), /*#__PURE__*/React.createElement(Title, {
    "data-testid": "details-title"
  }, title)), /*#__PURE__*/React.createElement(Box, {
    p: 1
  }, text == null ? void 0 : text.map((textBlock, index) => /*#__PURE__*/React.createElement(GuaranteeText, {
    key: index
  }, textBlock))));
};

process.env.NODE_ENV !== "production" ? GuaranteeDetails.propTypes = {
  title: string,
  text: arrayOf(string)
} : void 0;
GuaranteeDetails.defaultProps = {
  title: '',
  text: []
};
export default GuaranteeDetails;